<template>
  <form id="calc-part-1" class="calc">
    <section>
      <h2>Ange mått på utrymme, plattor samt fogbredd</h2>

      <div class="labelinput">
        <label for="i1"
          >Väggens, golvets, eller utrymmets bredd eller längd i m</label
        >
        <input id="i1" v-model.number="i1" type="text" class="in small" value="2,5" /><span
          class="unit"
          >m</span
        >
      </div>
      <div class="labelinput">
        <label for="i2">Plattans bredd i mm</label>
        <input id="i2" v-model.number="i2" type="text" class="in small" value="398" /><span
          class="unit"
          >mm</span
        >
      </div>
      <div class="labelinput">
        <label for="i3">Önskad fogbredd i mm</label>
        <input id="i3" v-model.number="i3" type="text" class="in small" value="3" /><span
          class="unit"
          >mm</span
        >
      </div>
      <div class="labelinput">
        <label for="i4"
          >Start- och slutavstånd (spalt) till angränsande vägg i mm</label
        >
        <input id="i4" v-model.number="i4" type="text" class="in small" value="10" /><span
          class="unit"
          >mm</span
        >
      </div>
      <div class="labelinput">
        <label for="r1">
          (Vägglängd för platta
          <span class="inline" id="r2"></span>
          plus fog
          <span class="inline" id="r3"></span>
          = <span class="inline" id="r8b"></span> mm)
        </label>
        <input id="r1" v-model.number="r1" type="text" class="out small" value="2480" /><span
          class="unit"
          >mm</span
        >
      </div>
    </section>

    <section>
      <h2>Beräkna antal plattor</h2>

      <div class="labelinput">
        <label for="r4"
          >Antal plattor <span class="inline" id="r14"></span>
          /
          <span class="inline" id="r15"></span
        ></label>
        <input id="r4" v-model.number="r4" type="text" class="out small" value="6,2" /><span
          class="unit"
          >st</span
        >
      </div>
      <div class="labelinput">
        <label for="r5">Avrundat ned:</label>
        <input id="r5" v-model.number="r5" type="text" class="out small" value="6" /><span
          class="unit"
          >st</span
        >
      </div>
      <div class="labelinput">
        <label for="i5"><strong>Justerat antal hela plattor:</strong></label>
        <input v-model.number="i5"
          id="i5"
          type="text"
          class="in small error"
          value=""
          style="border: 2px solid black; font-weight: bold"
        /><span class="unit">st</span>
      </div>
      <div class="labelinput">
        <label for="r6">
          Rest att fördela
          <span class="inline" id="r7"></span>
          x
          <span class="inline" id="r8"></span>
        </label>
        <input v-model.number="r6" id="r6" type="text" class="out small" value="" /><span
          class="unit"
          >mm</span
        >
      </div>
      <div class="labelinput">
        <label for="r9"><strong>Skärbitarnas mått:</strong></label>
        <input v-model.number="r9" id="r9" type="text" class="out small" value="" /><span
          class="unit"
          >mm</span
        >
      </div>

      <div class="labelinput" id="r11">
        <label style="color: red; width: 400px">
          Skärbitarna är mindre än 1/3 av en platta (<span
            class="inline"
            id="r13a"
          ></span>
          mm)
        </label>
        <button id="btnFewer" style="float: right">
          Justera antal plattor
        </button>
      </div>
      <div class="labelinput" id="r12">
        <label style="color: darkgreen">
          OK. Skärbitarna är större än 1/3 av en platta (<span
            class="inline"
            id="r13b"
          ></span>
          mm)
        </label>
      </div>
    </section>
  </form>
</template>

<script>

function recalculate(reset) {
    var r1 = (this.i1 * 1000 - 2 * this.i4);
    this.r1.val(Math.round(r1));

    this.r2.text(this.i2);
    this.r3.text(this.i3);

    var r4 = (this.r1 - this.i3) / (this.i2 + this.i3);
    this.r4.val(Math.round(r4 * 10) / 10);
    this.r5.val(Math.floor(r4));

    if (reset) this.i5.val(Math.floor(r4));

    var r7 = r4 - this.i5;
    this.r7.text(Math.round(r7 * 10) / 10);
    var r8 = this.i2 + this.i3;
    this.r8.text(Math.round(r8));
    this.r8b.text(Math.round(r8));
    var r6 = r7 * r8;
    this.r6.val(Math.round(r6));
    var r9 = r6 / 2;
    this.r9.val(Math.round(r9 * 10) / 10);
    var r10 = this.i2 / 3;
    this.r13a.text(Math.round(r10));
    this.r13b.text(Math.round(r10));

    this.r14.text(Math.round(r1));
    this.r15.text(Math.round(r8));

    if (r9 < r10) {
        this.r11.show();
        this.r12.hide();
        this.r9.addClass("error");
        this.r9.removeClass("strong");
    } else if (r9 > this.i2) {
        recalculate(true);
    } else {
        this.r11.hide();
        this.r12.show();
        this.r9.addClass("strong");
        this.r9.removeClass("error");
    }

    //this.r6").text("1 : " + Math.round(1000 / this.f1")));
    //this.f2-f").text("1 : " + Math.round(1000 / this.f2")));

    //var n1_2 = Math.round((this.t1-2") + this.l1-2") * this.f1-2") + this.l2-2") * this.f2-2")) * (-1));
    //this.n1-2").val(n1_2);
};

export default {
    

}
</script>